(() => {
  angular
    .module('app.topmenu')
    .controller('AccountSwitcherController', AccountSwitcher);

  AccountSwitcher.$inject = [
    '$scope',
    '$document',
  ];

  const KEY_ENTER = 13;

  function AccountSwitcher(
    $scope,
    $document,
  ) {
    const vm = this;
    vm.open = false;
    vm.query = '';

    const urLegacyUrl = 'https://admin.userreport.com/Websites/?context=';
    const urNewUrl = 'https://app.userreport.com/';

    const products = window.accountSwitcherAccounts || [];
    vm.products = products.map(product => ({
      name: product.name,
      logo: `../../assets/img/icons/Logos/${product.name}.svg`,
      accounts: product.accounts.map(account => {
        let url = account.url;
        if (/\/+$/.test(url)) {
          url = url.slice(0, -1); // remove trailing slash
        }

        if (url.includes(urLegacyUrl)) {
          url = url.replace(urLegacyUrl, urNewUrl);
        }

        return {
          ...account,
          url,
        };
      }),
    }));

    vm.searchAvailable = vm.products.reduce((memo, product) => memo + product.accounts.length, 0) > 10;

    if (vm.products.length === 0) {
      return;
    }

    const onClickOut = event => {
      if (vm.open && !event.target.closest('.account__switcher')) {
        vm.onToggle();
        $scope.$apply();
      }
    }

    vm.onToggle = () => {
      vm.open = !vm.open;

      if (vm.open) {
        $document.on('click', onClickOut);
      } else {
        $document.off('click', onClickOut);
      }
    }

    vm.onKeypress = event => {
      if (event.keyCode === KEY_ENTER) {
        const items = vm.products
          .reduce((memo, product) => ([...memo, ...product.accounts]), [])
          .filter(account => vm.onFilterAccount(account));

        if (items.length === 1 && !items[0].isCurrent) {
          window.location = items[0].url;
        }
      }
    }

    vm.filteredByProductAmount =  product => {
      const query = vm.query && vm.query.toLowerCase();
      return product.accounts.filter(({ name }) => name.toLowerCase().includes(query)).length;
    }

    vm.onFilterClear = () => {
      vm.query = '';
    }

    vm.onFilterProduct = product => {
      const query = vm.query && vm.query.toLowerCase();
      const hasAccounts = () =>
        product.accounts.filter(({ name }) => name.toLowerCase().includes(query)).length > 0;

      if (!query) {
        return true;
      }

      if (hasAccounts()) {
        return true;
      }

      return false;
    }

    vm.onFilterAccount = account => {
      const query = vm.query && vm.query.toLowerCase();
      const isInclude = ({ name }) => name.toLowerCase().includes(query);

      if (!query) {
        return true;
      }

      if (isInclude(account)) {
        return true;
      }

      return false;
    }
  }
})();
